<template>
	<div class="businessComment">
		<el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>话题PK</el-breadcrumb-item>
            <el-breadcrumb-item>商业评论</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="comment-add-box">
            <el-form :model="addCommentForm" :rules="validateRules" ref="addCommentForm" label-width="100px" class="addCommentForm">
            	<el-form-item label="创建者" prop="creater">
            		<el-select v-model="addCommentForm.creater" clearable filterable placeholder="请选择创建者或输入关键字">
	                    <el-option v-for="userItem in user.list" :key="user.userId" :label="userItem.userName" :value="userItem.userId"></el-option>
	                </el-select>
            	</el-form-item>
            	<el-form-item label="话题名称" prop="topicId">
            		<el-select v-model="addCommentForm.topicId" clearable filterable placeholder="请选择话题或输入关键字">
	                    <el-option v-for="topicItem in getTopicList" :key="topicItem.topicId" :label="topicItem.topicTitle" :value="topicItem.topicId"></el-option>
	                </el-select>
            	</el-form-item>
            	<el-form-item label="用户名" prop="userName">
                    <el-input v-model="addCommentForm.userName" auto-complete="off" placeholder="请输入用户名"></el-input>
                </el-form-item>
                <el-form-item label="头像地址" prop="userPortrait">
                    <el-input v-model="addCommentForm.userPortrait" auto-complete="off" placeholder="请输入头像地址"></el-input>
                </el-form-item>
                <el-form-item label="评论内容" prop="commentContent">
                    <el-input v-model="addCommentForm.commentContent" :autosize="{ minRows: 2, maxRows: 6}" type="textarea" auto-complete="off" placeholder="请输入评论内容"></el-input>
                </el-form-item>
                <el-form-item label="评论图片" prop="commentImg">
                    <el-input v-model="addCommentForm.commentImg" auto-complete="off" placeholder="请输入评论图片（选填）"></el-input>
                </el-form-item>
                <el-form-item label="点赞数" prop="likeNum">
                    <el-input v-model="addCommentForm.likeNum" auto-complete="off" placeholder="请输入点赞人数"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="addComment('addCommentForm')">立即创建</el-button>
                    <el-button @click="clearCommentData()">重置</el-button>
                </el-form-item>
            </el-form>
            <div class="comment-preview-box">
                <div class="say-sth" v-if="addCommentForm.commentContent !== '' && addCommentForm.userPortrait !== ''">
                	<div class="user">
                		<img :src="addCommentForm.userPortrait">
                    	<p>{{addCommentForm.userName}}</p>
                	</div>
                    <img v-if="addCommentForm.commentImg !== ''" :src="addCommentForm.commentImg" class="commentImg">
                    <div v-if="addCommentForm.commentContent !== ''" :class="[addCommentForm.commentImg == '' ? 'content' : 'isImg']"><span>{{addCommentForm.commentContent}}</span></div>
                    <div class="thumbs">
                    	<img src="http://localhost:8888/topicPK/images/thumbs.png">                                
                    	<span class="num">{{addCommentForm.likeNum}}</span><span> 赞</span>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";

export default {
	name: 'business',
	data () {
		var imgUrl = (rule, value, callback) => {
            var reg = new RegExp('^http(s)?://');
            if (value == '' || value == '请输入头像地址') {
                callback(new Error('请填写图片地址'));
            } else if (! reg.test(value)) {
                callback(new Error('您填写的地址不正确'));
            } else {
                callback();
            }
        }
        var comImgUrl = (rule, value, callback) => {
            var reg = new RegExp('^http(s)?://');
            if (value !== '' &&  value !== '请输入评论图片（选填）') {
                if (! reg.test(value)) {
                    callback(new Error('您填写的地址不正确'));
                }
            } else {
                callback();
            }
        }
        var topicId = (rule, value, callback) => {
            if (value == '') {
                callback(new Error('请选择一个话题'));
            } else {
                callback();
            }
        }
        return {
        	user: {
                current: null,
                list: null
            },
            topic: {
                current: null,
                list: null
            },
            addCommentForm: {
                creater: '',
                userId: 1,
				topicId: '',
                topicTitle: '',
				userName: '',
				userPortrait: '',
				commentContent: '',
				commentImg: '',
				likeNum: '0',
            },
            validateRules: {
                topicId: [
                    { required: true, validator: topicId, trigger: 'change' }
                ],
                userName: [
                    { required: true, message: '请填写用户名', trigger: 'change' }
                ],
                userPortrait: [
                    { required: true, validator: imgUrl, trigger: 'change' }
                ],
                commentContent: [
                    { required: true, message: '请填写评论内容', trigger: 'change' }
                ],
                likeNum: [ 
                    { required: true, message: '请填写点赞数', trigger: 'change' }
                ],
                commentImg: [
                    { required: false, validator: comImgUrl, trigger: 'change'}
                ]
            }
        }
	}, 
	mounted(){
        this._init();
    },
	computed: {
		getTopicList(){
            if (!this.user.current) {
                return this.topic.list;
                // return this.addCommentForm.topic.list;
            } else {
                let userId = this.user.current.userId;
                let topicList = this.topic.list;
                // let topicList = this.addCommentForm.topic.list;
                return topicList.filter((topicItem)=>{
                    return topicItem.createUser === userId;
                });
            }
        },
    },
    methods: {
    	_init () {
    		this._getUserList();
            this._getTopicList();
    	},
    	_getUserList() {
            this.$http.get(CONFIG.HOST + "/users/list" + '?t=' + TOOL.getCurrentTime()).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.user.list = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        _getTopicList(){
            this.$http.get(CONFIG.HOST + '/topicPK/topics/getAllTopics' + '?t=' + TOOL.getCurrentTime()).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.topic.list = result.data;
                    // this.addCommentForm.topic.list = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
    	addComment(formName) {
    		// this.addCommentForm.topicId = this.topic.current.topicId;
            let flag = true;
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    flag = false;
                    return false;
                }
            });
            if (!flag) {
                this.$notify.error({
                    message: '请检查要添加的数据'
                });
                return;
            }
            this.$http.post(CONFIG.HOST + '/topicPK/comments/addBusComment', this.addCommentForm).then((response) => {
                console.log(response);
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '【营销平台】商业评论添加成功'
                    });
                    this.clearCommentData();
                    // router.push({
                    //     name: 'topicList'
                    // });
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        clearCommentData() {
            this.$refs.addCommentForm.resetFields();
            console.log(this.addCommentForm);
        },
    }
}
</script>

<style lang="less">
	.businessComment{
		width: 98%;
	    margin: 0 auto;
	    .el-form-item__label {
	        font-weight: bold;
	    }
	    .el-switch {
	        position: absolute;
	        left: 0;
	        top: 7px;
	    }
	    .bread-nav {
	        margin: 20px 0;
	    }
	    .comment-add-box {
	        width: 980px;
	        position: relative;
	        left: 0;
	        top: 0;
	        
            .addCommentForm {
	            width: 440px;
	            position: absolute;
	            left: 0;
	            top: 0;

	            .el-select {
	            	width: 100%;
	            }
	        }

	        .comment-preview-box {
	            width: 360px;
	            min-height: 360px;
	            border: 1px solid #bfcbd9;
	            border-radius: 6px;
	            position: absolute;
	            left: 550px;
	            top: 0;
	            
	            .say-sth {
	                // border: 2px dashed #9C9C9C;
	                width: 320px;
	                min-height: 320px;
	                margin: 20px;
	                font-size: 20px;
	                background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAFABAMAAABOz0FrAAAAFVBMVEWXjcOUicGRhr+Og76MgL2KfruGe7miZTg0AAAC+UlEQVRIxyzPS5LUMBCE4a9sD+uSmpm1ZANruw2shx5gDcPjAgT3vwIoIDeqyMj6lUWfiyoSpgm1EQxnbVTTedbXtxIcyhGXZijkFAy9TiEGpVfWiCymI8MZ/4FLPwS+M5xZ9SnnU9ruf4l0jcd4mnbRBqhsmf5r5OW2h5q4v637kmsOymhXd/1ig6vI0IO73V3DcpaTt4n3T6/S9YQqzV+ZBRlnDms5iavV6s1uvu1O3c9m66mfaaPD1VAvIVoQv3p5eU4mbM10EJbH+mhwWZrRZUojEp/S9nyx+rska3kSYq2yxCEimjV1piDSWMsMkVHdif0hJ7Wpojm6mrFBSaGGa6qonWr+WZ6z3Cc59WGFMcoc22SkHDm2aHPXXHkyPhA30vyNKIkY50zJq3xo+JyhOFhf/hrPRN5duoBiUqyYvsTHWHUZ9fHF7pBuxOt919nlXItohupESFIuuexzCrGHNYPRK6aV4HUrLZJQTgURxZFY28OnVdIuVw+/k2DZPfxApIktGRymhp7RzaOU9YwP3u2B6NLVNLKFFx+MsZL3zYtnFqUE919DvfXE20Y9OhlFMJTSYs7LLT5cnp2WFs94tHmTuSuZ29XbghRPTIPy74mjrHHE1UyKiIM7RDGOfSVyPsQfdsomN2EghsKfZwhrewJdewLteiZB3RcQFyi9Qu5/hMoix2Bv6f3400uOkbRUjpOG605lbFxGZk9K8hRvJMfdpQnRHzV1CmZjUOlUVIH8R3kRxX5mPDGDstCpIeKfv2IVDPJZKQ0EioZfQUgVSNz40Ee3stWwobdHrCB9cFkpDqkedLhxd0BgnbgBRNvGCfzYWYMthp6bPB0kfU0w3QGkKLlBhoKSUCYANZOWrxhMq4tOzlKRpwo1ooe2gkFQHpavsIjz+PFxgUhzh5RAsw4KAL5DoQLiNrQi56aYsJtntrnaGVylxm0YVBrC4EQ5ispDOVyoYMu3vVbzvb/v/f3faPk7Wv6Olr+j5e9o+Tta/pJa/gIAzVzBLGXn67AAAAAASUVORK5CYII='); 
	                .commentImg {
	                	width: 100%;
	                }
	                .user {
	                	text-align: left;
                        padding: 3.6%;
                        word-wrap: break-word;
	                	img {
                            float: left;
	                		width: 10%;
		                    border-radius: 50%;
		                    vertical-align: middle;
		                    // float: left;
		                    // margin-right: 3.6%;
	                	}
                        p {
                            margin-left: 13.6%;
                        }
	                }
	                .content {
	                    margin: 20px;
	                    min-height: 140px;
	                    // text-align: center;
	                    display: flex; 
	                    justify-content: center; 
	                    align-items: center; 
                        word-wrap: break-word;
                        span {
                            display: block;
                            max-width: 280px;
                        }
	                }
	                .isImg {
	                	padding: 20px;
	                    text-align: left;
                        word-wrap: break-word;

	                }
	                .thumbs{
	                	text-align: left;
	                	padding: 40px 20px 20px;
	                	// margin-top: 40px;
						img {
							width: 9%;
		                    vertical-align: middle;
						}
	                	span {
		                    vertical-align: middle;
	                		margin-bottom: 5px;
	                	}
	                }
	            }
	        }
	    }
	}
</style>


// WEBPACK FOOTER //
// Business.vue?6e2b5117